import i18n from '@/utils/i18n';
import React from 'react';
import { FilterType } from '@/components/filter-button';
import { HorizontalSelector } from '@/components/horizontal-selector';
import { PartitionFilterType } from '@/contexts/item-context-types';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';

const ALL_FILTER: PartitionFilterType = {
  metadata: { isDefault: false },
  title: i18n.t('all'),
  value: 'ALL_FILTER',
};

export interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  partitionFilter: PartitionFilterType | null;
  partitions: PartitionFilterType[];
  setPartitionFilter: (partition: PartitionFilterType | null) => void;
  showAllFilter?: boolean;
}

export const PartitionSelector: React.FC<Props> = ({
  containerStyle,
  partitionFilter,
  partitions,
  setPartitionFilter,
  showAllFilter = false,
}) => {
  return (
    <HorizontalSelector<PartitionFilterType>
      allFilter={showAllFilter ? ALL_FILTER : undefined}
      containerStyle={containerStyle}
      contentContainerStyle={styles.flush}
      data={partitions}
      filterType={FilterType.TAB}
      keyExtractor={(item) => String(item.value)}
      onItemPress={setPartitionFilter}
      selectedItem={partitionFilter}
      trackingKey="partition_selector"
    />
  );
};

const styles = StyleSheet.create({
  flush: {
    marginLeft: 0,
  },
});
